import Data from '@/public/data/GruppOne.json'
import styles from '@/styles/About.module.css'
import Image from 'next/image'
import HomeImage from '@/public/img/Home.webp'
import { useTranslation } from 'react-i18next'

const GruppOne = () => {
  const grayscaleStyle = {
    filter: 'grayscale(100%)', // Apply grayscale filter
  }
  const { t, i18n } = useTranslation()

  return (
    <section className={styles.cardContainer}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2>{t('Pizza Group')} 1: 110kr</h2>
          <div className={styles.additional}>
            <span>Barn 100kr</span>
            <span> {t('Familj')} 300kr</span>
          </div>
        </div>
        <main className={styles.cardsContainer}>
          {Data &&
            Data.map((data, id) => {
              return (
                <ol role='list' className={styles.cardItem} key={id}>
                  <li className={styles.imageContainer}>
                    <div className={styles.imageWrapper}>
                      <Image
                        src={data.imageUrl || HomeImage}
                        className={styles.imageUrl}
                        width={200}
                        height={100}
                        alt={data.alt}
                        aria-label={data.alt || 'Image Not Available'}
                        loading='lazy'
                        style={data.imageUrl ? {} : grayscaleStyle}
                      />
                      {!data.imageUrl && (
                        <span
                          className={styles.comingSoon}
                          aria-label='Image Not Available'
                        >
                          {t('Image Not Available')}
                        </span>
                      )}
                    </div>
                  </li>
                  <figcaption className={styles.figCaption}>
                    {data.Name}
                  </figcaption>
                  {data.Ingred ? (
                    <span className={styles.cardSpan}>{t(data.Ingred)}</span>
                  ) : null}
                  <div className={styles.cardItemWrapper}>
                    {data.Barn ? (
                      <span className={styles.cardSpan}>
                        Barn: {data.Barn}kr
                      </span>
                    ) : null}
                    {data.Regular ? (
                      <span className={styles.cardSpan}>
                        Regular: {data.Regular}kr
                      </span>
                    ) : null}
                    {data.Familj ? (
                      <span className={styles.cardSpan}>
                        {t('Familj')}: {data.Familj}kr
                      </span>
                    ) : null}
                  </div>
                </ol>
              )
            })}
        </main>
      </div>
    </section>
  )
}
export default GruppOne
